<template>
  <o-card>
    <template slot="header">
      <h5 class="mb-0">{{ $t('sandoz.verification') }}</h5>
    </template>

    <o-form-group :label="$t('sandoz.compliance_check')">
      <b-form-radio-group v-model="item.compilance_check_selected"
                          :options="complianceOptions"
                          :disabled="readonly"/>
    </o-form-group>

    <o-form-group v-if="String(item.compilance_check_selected) === '0'"
                  :label="$t('sandoz.compliance_check_note')">
      <b-form-textarea v-model="item.compilance_check_note" rows="3" :disabled="readonly"/>
    </o-form-group>

    <o-form-group :label="$t('sandoz.compliance_deviation')">
      <b-form-textarea v-model="item.compliance_deviation" rows="3" :disabled="readonly"/>
    </o-form-group>

    <o-form-group :label="$t('sandoz.compliance_check_file')">
      <a v-if="item.compilance_check_file" :href="item.compilance_check_file" target="_blank">
        {{ $t('sandoz.compliance_check_file_open') }}
      </a>
      <span v-else class="text-muted">{{ $t('sandoz.no_file_uploaded') }}</span>
    </o-form-group>

    <hr/>
    <h6>{{ $t('sandoz.verification_per_address') }}</h6>
    <p v-if="!verificationRows.length" class="text-muted">{{ $t('sandoz.no_verification_rows') }}</p>
    <table v-else class="table table-sm">
      <thead>
        <tr>
          <th>{{ $t('sandoz.address') }}</th>
          <th>{{ $t('sandoz.verified_quantity') }}</th>
          <th>{{ $t('sandoz.verified_at') }}</th>
          <th>{{ $t('sandoz.status') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in verificationRows" :key="row.id">
          <td>{{ row.address_name || row.address_id }}</td>
          <td>{{ row.verified_quantity }}</td>
          <td>{{ row.verified_at }}</td>
          <td>{{ row.status }}</td>
        </tr>
      </tbody>
    </table>
  </o-card>
</template>

<script>
import sectionMixin from '../sectionMixin'

/**
 * Verification flow. Source: kam/ContractDetail.vue. The full address-level verification picker
 * (KamVerificationController integration) is read-only here — write paths follow during the
 * cutover. Compliance fields keep their legacy 'compilance_check_*' column names (typo
 * preserved to avoid migrations).
 */
export default {
  name: 'SectionVerification',
  mixins: [sectionMixin],
  data() {
    return {
      complianceOptions: [
        { value: 1, text: this.$t('sandoz.yes') },
        { value: 0, text: this.$t('sandoz.no') }
      ]
    }
  },
  computed: {
    verificationRows() {
      const rows = []
      const addresses = Array.isArray(this.item.addresses) ? this.item.addresses : []
      addresses.forEach(addr => {
        if (Array.isArray(addr.verifications)) {
          addr.verifications.forEach(v => rows.push({
            ...v,
            address_name: addr.company_name
          }))
        }
      })
      return rows
    }
  }
}
</script>
